import PropTypes from 'prop-types';

export const reactRef = PropTypes.oneOfType([
  PropTypes.func,
  PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
]);

export default reactRef;
